/** @format */

import React from "react";

function Fixer({ c, setC, bc, setBc, date }) {
  const changeBox = (status, h, s, b) => {
    let d = [...c];
    let cb = [...bc];
    b.map((i) => {
      cb[i] = status ? 1 : 0;
    });
    d[h] = status ? s : 0;
    setC(d);
    setBc(cb);
  };

  return (
    <ul>
      <li>
        <p>Sug‘orish ishlariga olingan suv miqdori</p>
        <ul>
          <li>
            <p>
              <input
                id='ch1'
                type='checkbox'
                onChange={(e) => changeBox(e.target.checked, 1, 2, [1, 2])}
                checked={c[1] == 0 ? false : true}
              />
              <label htmlFor='ch1'>1.04-{date} y. mln.m3</label>
            </p>
          </li>

          <li>
            <p>
              <input
                id='ch2'
                type='checkbox'
                onChange={(e) => changeBox(e.target.checked, 2, 2, [3, 4])}
                checked={c[2] == 0 ? false : true}
              />
              <label htmlFor='ch2'>
                Kunlik suv sarfi m<sup>3</sup>/s.
              </label>
            </p>
          </li>
        </ul>
      </li>

      <li>
        <p>Sug‘orilgan maydon, ming ga</p>
        <ul>
          <li>
            <p>
              <input
                id='ch3'
                type='checkbox'
                onChange={(e) => changeBox(e.target.checked, 3, 2, [5, 6])}
                checked={c[3] == 0 ? false : true}
              />
              <label htmlFor='ch3'>Jami sug‘orish ishlari</label>
            </p>
          </li>

          <li>
            <p>shundan</p>
            <ul>
              <li>
                <p>
                  <input
                    id='ch4'
                    type='checkbox'
                    onChange={(e) => changeBox(e.target.checked, 4, 2, [7, 8])}
                    checked={c[4] == 0 ? false : true}
                  />
                  <label htmlFor='ch4'>
                    G‘alla ekishdan oldingi sho‘r yuvish <br /> va nam suvi
                    berish
                  </label>
                </p>
              </li>

              <li>
                <p>G‘alla sug‘orish</p>
                <ul>
                  <li>
                    <p>
                      <input
                        id='ch5'
                        type='checkbox'
                        onChange={(e) =>
                          changeBox(e.target.checked, 5, 1, [0, 9])
                        }
                        checked={c[5] == 0 ? false : true}
                      />
                      <label htmlFor='ch5'>Reja</label>
                    </p>
                  </li>

                  <li>
                    <p>
                      <input
                        id='ch6'
                        type='checkbox'
                        onChange={(e) =>
                          changeBox(e.target.checked, 6, 1, [0, 10])
                        }
                        checked={c[6] == 0 ? false : true}
                      />
                      <label htmlFor='ch6'>1 kunda</label>
                    </p>
                  </li>

                  <li>
                    <p>
                      <input
                        id='ch7'
                        type='checkbox'
                        onChange={(e) =>
                          changeBox(e.target.checked, 7, 1, [0, 11])
                        }
                        checked={c[7] == 0 ? false : true}
                      />
                      <label htmlFor='ch7'>jami ekilgandan boshlab</label>
                    </p>
                  </li>

                  <li>
                    <p>shu jumladan</p>
                    <ul>
                      <li>
                        <p>
                          <input
                            id='ch8'
                            type='checkbox'
                            onChange={(e) =>
                              changeBox(e.target.checked, 8, 2, [12, 13])
                            }
                            checked={c[8] == 0 ? false : true}
                          />
                          <label htmlFor='ch8'>1-suv</label>
                        </p>
                      </li>

                      <li>
                        <p>
                          <input
                            id='ch9'
                            type='checkbox'
                            onChange={(e) =>
                              changeBox(e.target.checked, 9, 2, [14, 15])
                            }
                            checked={c[9] == 0 ? false : true}
                          />
                          <label htmlFor='ch9'>2-suv</label>
                        </p>
                      </li>

                      <li>
                        <p>
                          <input
                            id='ch10'
                            type='checkbox'
                            onChange={(e) =>
                              changeBox(e.target.checked, 10, 2, [16, 17])
                            }
                            checked={c[10] == 0 ? false : true}
                          />
                          <label htmlFor='ch10'>3-suv</label>
                        </p>
                      </li>

                      <li>
                        <p>
                          <input
                            id='ch11'
                            type='checkbox'
                            onChange={(e) =>
                              changeBox(e.target.checked, 11, 2, [18, 19])
                            }
                            checked={c[11] == 0 ? false : true}
                          />
                          <label htmlFor='ch11'>4-suv</label>
                        </p>
                      </li>

                      <li>
                        <p>
                          <input
                            id='ch12'
                            type='checkbox'
                            onChange={(e) =>
                              changeBox(e.target.checked, 12, 2, [20, 21])
                            }
                            checked={c[12] == 0 ? false : true}
                          />
                          <label htmlFor='ch12'>5-suv</label>
                        </p>
                      </li>

                      <li>
                        <p>
                          <input
                            id='ch13'
                            type='checkbox'
                            onChange={(e) =>
                              changeBox(e.target.checked, 13, 2, [22, 23])
                            }
                            checked={c[13] == 0 ? false : true}
                          />
                          <label htmlFor='ch13'>6-suv</label>
                        </p>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>

              <li>
                <p>G‘o‘za sug‘orish</p>
                <ul>
                  <li>
                    <p>
                      <input
                        id='ch14'
                        type='checkbox'
                        onChange={(e) =>
                          changeBox(e.target.checked, 14, 1, [0, 24])
                        }
                        checked={c[5] == 0 ? false : true}
                      />
                      <label htmlFor='ch14'>Reja</label>
                    </p>
                  </li>

                  <li>
                    <p>
                      <input
                        id='ch15'
                        type='checkbox'
                        onChange={(e) =>
                          changeBox(e.target.checked, 15, 1, [0, 25])
                        }
                        checked={c[6] == 0 ? false : true}
                      />
                      <label htmlFor='ch15'>1 kunda</label>
                    </p>
                  </li>

                  <li>
                    <p>
                      <input
                        id='ch16'
                        type='checkbox'
                        onChange={(e) =>
                          changeBox(e.target.checked, 16, 1, [0, 26])
                        }
                        checked={c[7] == 0 ? false : true}
                      />
                      <label htmlFor='ch16'>jami ekilgandan boshlab</label>
                    </p>
                  </li>

                  <li>
                    <p>shundan</p>
                    <ul>
                      <li>
                        <p>
                          <input
                            id='ch17'
                            type='checkbox'
                            onChange={(e) =>
                              changeBox(e.target.checked, 17, 2, [27, 28])
                            }
                            checked={c[17] == 0 ? false : true}
                          />
                          <label htmlFor='ch17'>1-suv</label>
                        </p>
                      </li>

                      <li>
                        <p>
                          <input
                            id='ch18'
                            type='checkbox'
                            onChange={(e) =>
                              changeBox(e.target.checked, 18, 2, [29, 30])
                            }
                            checked={c[18] == 0 ? false : true}
                          />
                          <label htmlFor='ch18'>2-suv</label>
                        </p>
                      </li>

                      <li>
                        <p>
                          <input
                            id='ch19'
                            type='checkbox'
                            onChange={(e) =>
                              changeBox(e.target.checked, 19, 2, [31, 32])
                            }
                            checked={c[19] == 0 ? false : true}
                          />
                          <label htmlFor='ch19'>3-suv</label>
                        </p>
                      </li>

                      <li>
                        <p>
                          <input
                            id='ch20'
                            type='checkbox'
                            onChange={(e) =>
                              changeBox(e.target.checked, 20, 2, [33, 34])
                            }
                            checked={c[20] == 0 ? false : true}
                          />
                          <label htmlFor='ch20'>4-suv</label>
                        </p>
                      </li>

                      <li>
                        <p>
                          <input
                            id='ch21'
                            type='checkbox'
                            onChange={(e) =>
                              changeBox(e.target.checked, 21, 2, [35, 36])
                            }
                            checked={c[21] == 0 ? false : true}
                          />
                          <label htmlFor='ch21'>5-suv</label>
                        </p>
                      </li>

                      <li>
                        <p>
                          <input
                            id='ch22'
                            type='checkbox'
                            onChange={(e) =>
                              changeBox(e.target.checked, 22, 2, [37, 38])
                            }
                            checked={c[22] == 0 ? false : true}
                          />
                          <label htmlFor='ch22'>6-suv</label>
                        </p>
                      </li>

                      <li>
                        <p>
                          <input
                            id='ch23'
                            type='checkbox'
                            onChange={(e) =>
                              changeBox(e.target.checked, 23, 2, [39, 40])
                            }
                            checked={c[23] == 0 ? false : true}
                          />
                          <label htmlFor='ch23'>7-suv</label>
                        </p>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>

              <li>
                <p>
                  <input
                    id='ch24'
                    type='checkbox'
                    onChange={(e) =>
                      changeBox(e.target.checked, 24, 2, [41, 42])
                    }
                    checked={c[24] == 0 ? false : true}
                  />
                  <label htmlFor='ch24'>Takroriy ekin sug‘orish</label>
                </p>
              </li>

              <li>
                <p>
                  <input
                    id='ch25'
                    type='checkbox'
                    onChange={(e) =>
                      changeBox(e.target.checked, 25, 3, [43, 44, 45])
                    }
                    checked={c[25] == 0 ? false : true}
                  />
                  <label htmlFor='ch25'>
                    Pushta va nam suvi berish ishlari
                  </label>
                </p>
              </li>

              <li>
                <p>
                  <input
                    id='ch26'
                    type='checkbox'
                    onChange={(e) =>
                      changeBox(e.target.checked, 26, 2, [46, 47])
                    }
                    checked={c[26] == 0 ? false : true}
                  />
                  <label htmlFor='ch26'>
                    Tomorqa va boshqa sug‘orish ishlari
                  </label>
                </p>
              </li>
            </ul>
          </li>

          <li>
            <p>
              <input
                id='ch27'
                type='checkbox'
                onChange={(e) => changeBox(e.target.checked, 27, 2, [48, 49])}
                checked={c[27] == 0 ? false : true}
              />
              <label htmlFor='ch27'>
                G‘alla ekishdan oldingi nam suvi berish
              </label>
            </p>

            <ul>
              <li>
                <p>shu jumladan</p>
                <ul>
                  <li>
                    <p>
                      <input
                        id='ch28'
                        type='checkbox'
                        onChange={(e) =>
                          changeBox(e.target.checked, 28, 2, [50, 51])
                        }
                        checked={c[28] == 0 ? false : true}
                      />
                      <label htmlFor='ch28'>ochiq maydon</label>
                    </p>
                  </li>

                  <li>
                    <p>
                      <input
                        id='ch29'
                        type='checkbox'
                        onChange={(e) =>
                          changeBox(e.target.checked, 29, 2, [52, 53])
                        }
                        checked={c[29] == 0 ? false : true}
                      />
                      <label htmlFor='ch29'>g‘o‘za qator orasi</label>
                    </p>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
  );
}

export default Fixer;
